import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import {
  getAllPaymentsInitiate,
  upsertPaymentInitiate,
} from '../../../../actions/payments';
import PaymentUpdate from './PaymentUpdate';
import { currentFlowTypeEnum } from '../constants';

const mapStateToProps = state => {
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', []);
  const currentFlow = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  return {
    currentFlow,
    ...state,
    selectedWorkspace,
    upsertingPayment:
      _get(state, 'apiState.UPSERT_PAYMENT.isFetching', false) &&
      !_get(state, 'apiState.UPSERT_PAYMENT.isIdle', true),

    upsertPaymentSuccess: _get(state, 'apiState.UPSERT_PAYMENT.success', false),
  };
};

const mapDispatchToProps = dispatch => ({
  upsertPayment: payload => dispatch(upsertPaymentInitiate(payload)),
  getAllPayments: payload => dispatch(getAllPaymentsInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PaymentUpdate);
